import styled, { css } from 'styled-components';

export const BlockWrapper = styled.div`
  [class^='Blockstyle__Block-sc'] {
    padding: 32px 16px;

    @media (min-width: 768px) {
      padding: 0px 20px 0px 20px;
    }

    [class^='Blockstyle__ContentWrapper-sc'] {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 1280px;
    }
  }
`;

export const whiteCSS = css`
  background-color: var(--white);
`;

export const galleryCSS = css`
  background-color: var(--gallery);
`;


export const ContainerWrapper = styled.div<{ isImageLeft: boolean }>`
  display: flex;
  flex-direction: ${props => (props.isImageLeft ? 'row-reverse' : 'row')};

  @media (max-width: 1024px) {
    padding: 0 20px;
  }

  @media (max-width: 794px) {
    flex-direction: ${props => (props.isImageLeft ? 'column' : 'column-reverse')};
    padding: 0px;
    align-items: center;
  }
`;

export const ContentWrapper = styled.div<{ isImageLeft: boolean }>`
  display: flex;
  align-items: center;
  margin-right: ${props => (props.isImageLeft ? '0px' : '20px')};
  margin-left: ${props => (props.isImageLeft ? '20px' : '0px')};
  flex: 1;

  [class^='RichTextstyles__ParsedContentWrapper'] {
    p {
      font-size: 20px;
      line-height: 28px;
    }
  }

  @media (max-width: 794px) {
    margin-right: 0px;
    margin-left: 0px;
    
    [class^='RichTextstyles__ParsedContentWrapper'] {
      text-align: center;
      
      p {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
`;

export const ImageWrapper = styled.div`
  flex: 1.4;
  width: 100%;
  margin-top: 19px;

  .gatsby-image-wrapper {
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 794px) {
    margin-top: 0px;
    width: 100%;

    .gatsby-image-wrapper {
      height: 70%;
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const RichTextWrapper = styled.div`
  p {
    font-size: 18px;
    line-height: 28px;
  }
`;
